// Adaptive visual quality presets for cube rendering by size and device class.

export const FACE_COLORS = [
  0xfaf4ed, // U base
  0xea9d34, // D gold
  0xb4637a, // R love
  0xd7827e, // L rose
  0x56949f, // F foam
  0x907aa9, // B iris
];

export const MAX_RENDER_PIXEL_RATIO = 2;

export function renderPixelRatio(devicePixelRatio = 1) {
  const ratio = Number(devicePixelRatio);
  return Number.isFinite(ratio) && ratio > 0
    ? Math.min(ratio, MAX_RENDER_PIXEL_RATIO)
    : 1;
}

export function qualityPreset(N, deviceClass = "high") {
  // deviceClass: 'low' | 'high'
  const large = N > 30;
  const medium = N > 10;
  return {
    cubieSegments: large ? 1 : medium ? 2 : 3,
    cubieRadius: large ? 0.012 : medium ? 0.02 : 0.028,
    cubieScale: large ? 0.995 : medium ? 0.98 : 0.965,
    stickerRadius: large ? 0.006 : medium ? 0.009 : 0.012,
    stickerScale: large ? 0.88 : medium ? 0.83 : 0.78,
    stickerSegments: large ? 1 : medium ? 1 : 2,
    stickerDepth: large ? 0.01 : medium ? 0.016 : 0.028,
    stickerInset: large ? 0.002 : medium ? 0.004 : 0.008,
    stickerBevel: large ? 0.003 : medium ? 0.005 : 0.009,
    stickerBevelSegments: large ? 1 : medium ? 1 : 2,
    envIntensity: large ? 0.8 : 1.0,
    deviceClass,
  };
}

export function estimateDeviceClass() {
  try {
    const gl =
      document.createElement("canvas").getContext("webgl2") ||
      document.createElement("canvas").getContext("webgl");
    if (!gl) return "low";
    const dbg = gl.getExtension("WEBGL_debug_renderer_info");
    const renderer = dbg
      ? String(gl.getParameter(dbg.UNMASKED_RENDERER_WEBGL) || "")
      : "";
    const mem = navigator.deviceMemory || 8;
    const lowGpu = /swiftshader|llvmpipe|software|angle \(software/i.test(
      renderer,
    );
    return lowGpu || mem <= 2 ? "low" : "high";
  } catch {
    return "high";
  }
}
